    <div v-if="isOpen" class="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
        <div class="bg-slate-900 border border-slate-700 text-slate-100 rounded-xl shadow-2xl w-full max-w-2xl overflow-hidden flex flex-col max-h-[85vh]">
            
            <!-- Modal Header -->
            <div class="flex justify-between items-center px-6 py-4 border-b border-slate-800 bg-slate-950/50">
                <h3 class="text-lg font-bold text-slate-100 flex items-center gap-2">
                    <span class="pi pi-file text-4xl text-indigo-100"></span>
                    <span>{{ isModalReadOnly ? `Detail Record ${alias}` : `Edit Record ${alias}` }}</span>
                </h3>
                <button @click="$emit('close')"
                    class="text-slate-400 hover:text-white bg-slate-800 hover:bg-slate-700 rounded-full p-1.5 transition-colors cursor-pointer text-sm">
                    <span class="pi pi-times-circle text-4xl text-indigo-100"></span>
                </button>
            </div>

            <!-- Modal Body -->
            <div class="p-6 overflow-y-auto grow">
                
                <!-- Alerts -->
                <div v-if="modalError" class="mb-4 p-3 rounded bg-rose-500/10 border border-rose-500/20 text-rose-400 text-sm">
                    {{ modalError }}
                </div>
                <div v-if="modalSuccess" class="mb-4 p-3 rounded bg-emerald-500/10 border border-emerald-500/20 text-emerald-400 text-sm">
                    {{ modalSuccess }}
                </div>

                <!-- 1. READ-ONLY MODE (View Only Table) -->
                <table v-if="isModalReadOnly" class="w-full text-left text-sm border-collapse">
                    <thead>
                        <tr class="border-b border-slate-800 text-slate-400 uppercase text-xs tracking-wider">
                            <th class="py-2 px-3">Description</th>
                            <th class="py-2 px-3">Value</th>
                        </tr>
                    </thead>
                    <tbody class="divide-y divide-slate-800/60">
                        <tr v-for="data in newModalFields" :key="data.label" class="hover:bg-slate-800/30">
                            <td class="py-2.5 px-3 font-semibold text-cyan-400 w-1/3">
                                {{ getHeaderName(data.label) }}
                            </td>
                            <td class="py-2.5 px-3 text-slate-200 break-all">
                                <span v-if="data.value === null || data.value === undefined" class="text-slate-500 italic">null</span>
                                <span v-else>{{ data.value }}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <!-- 2. EDIT FORM MODE -->
                <form v-else id="modalForm" @submit.prevent="handleSave" class="space-y-4">
                    <div v-for="field in modalFields" :key="field.id" class="flex flex-col">
                        
                        <label :for="`modal-${field.id}`" class="block text-xs font-semibold text-slate-300 mb-1">
                            {{ field.label }}
                            <span v-if="field.isReadOnly" class="text-[10px] text-amber-400 font-normal ml-1 bg-amber-400/10 px-1.5 py-0.5 rounded border border-amber-400/20">
                                Read-Only
                            </span>
                            <span v-else-if="field.required" class="text-rose-400">*</span>
                        </label>

                        <!-- A. READ-ONLY INPUT FIELD -->
                        <input 
                            v-if="field.isReadOnly"
                            :id="`modal-${field.id}`"
                            v-model="editForm[field.id]"
                            type="text"
                            readonly
                            class="w-full rounded-md bg-slate-950/60 px-3 py-2 text-sm text-slate-400 border border-slate-800 cursor-not-allowed focus:outline-none" 
                        />

                        <!-- B. SELECT INPUT FIELD -->
                        <select 
                            v-else-if="field.type === 'select'"
                            :id="`modal-${field.id}`"
                            v-model="editForm[field.id]"
                            :required="field.required"
                            class="w-full rounded-md bg-slate-800 px-3 py-2 text-sm text-white border border-slate-700 focus:ring-2 focus:ring-indigo-500 focus:outline-none cursor-pointer">
                            <option value="" disabled class="bg-slate-800 text-gray-400">Select {{ field.label }}</option>
                            <option v-for="opt in field.options" :key="opt" :value="opt" class="bg-slate-800 text-white">
                                {{ opt }}
                            </option>
                        </select>

                        <!-- C. EDITABLE TEXT INPUT FIELD -->
                        <input 
                            v-else
                            :id="`modal-${field.id}`"
                            v-model="editForm[field.id]"
                            :type="field.type || 'text'"
                            :placeholder="field.placeholder || ''"
                            :required="field.required"
                            class="w-full rounded-md bg-slate-800 px-3 py-2 text-sm text-white border border-slate-700 focus:ring-2 focus:ring-indigo-500 focus:outline-none transition-all" 
                        />
                    </div>
                </form>

            </div>

            <!-- Modal Footer -->
            <div class="px-6 py-3 border-t border-slate-800 bg-slate-950/50 flex justify-end gap-3">
                <div v-if="level != 'karyawan' && typeMenu == 'approval'" class="flex justify-between gap-3">
                    <button 
                        @click="handleApprove()"
                        type="button"
                        class="px-4 py-2 bg-green-800 hover:bg-green-700 active:bg-green-600 text-slate-200 rounded-lg text-sm font-medium transition-colors cursor-pointer">
                        <span v-if="isLoading">
                            <i class="fa-solid fa-circle-notch fa-spin"></i>
                        </span>
                        <span v-else >Approve</span>
                    </button>
                    <button 
                        @click="handleReject()"
                        type="button"
                        class="px-4 py-2 bg-red-800 hover:bg-red-700 active:bg-red-600 text-slate-200 rounded-lg text-sm font-medium transition-colors cursor-pointer">
                        Reject
                    </button>
                </div>
                <button 
                    @click="$emit('close')"
                    type="button"
                    class="px-4 py-2 bg-slate-800 hover:bg-slate-700 active:bg-slate-600 text-slate-200 rounded-lg text-sm font-medium transition-colors cursor-pointer">
                    {{ isModalReadOnly ? 'Close' : 'Cancel' }}
                </button>

                <button 
                    v-if="!isModalReadOnly"
                    form="modalForm"
                    type="submit"
                    :disabled="isSaving"
                    class="px-5 py-2 bg-indigo-600 hover:bg-indigo-500 active:bg-indigo-700 text-white rounded-lg text-sm font-semibold transition-all flex items-center gap-2 cursor-pointer disabled:opacity-50">
                    <span v-if="isSaving" class="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full"></span>
                    <span>{{ isSaving ? 'Saving...' : 'Save Changes' }}</span>
                </button>
            </div>

        </div>
    </div>
